import React, { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { isTextTruncated } from "@/util/stringUtil";
import { useScenario, useRecentScenarios } from "@/query/scenario";
import { useRouteHandler } from "@/hook/useRouteHandler";
import Tooltip from "@/component/Tooltip";
import { DropdownGroup, DropdownButton, DropdownFooter, DropdownItem, DropdownItems } from "@/component/input";


const ScenarioDropdown: React.FC<{scenarioId: string}> = ({ scenarioId }) => {
    const intl = useIntl();
    const { moveToScenarioPage, moveToDashboard } = useRouteHandler();

    const btnTextRef = useRef<HTMLButtonElement>(null);
    const [isTruncated, setIsTruncated] = useState<boolean>(false);

    const { data: scenario } = useScenario(scenarioId);
    const { data: recentScenarios } = useRecentScenarios();

    const onClickScenario = (scenarioId: string) => {
        moveToDashboard(scenarioId);
    };
    const onClickMore = () => {
        moveToScenarioPage();
    };

    useEffect(() => {
        setIsTruncated(isTextTruncated(btnTextRef.current!));
    }, [scenario?.name]);

    return (
        <DropdownGroup className="z-20">
            <DropdownButton as="div"
                            iconClassName="!size-5"
                            className="w-full outline-0 !py-0 cursor-pointer hover:bg-chat42-10"
            >
                <Tooltip message={scenario!.name}
                         placement="bottom-start"
                         disable={!isTruncated}
                         tooltipClassName="-ml-3.5 w-full h-[44px] flex items-center text-[16px] font-[400]"
                >
                    <button ref={btnTextRef}
                            className="w-full pt-2 pb-1.5 text-chat42 text-[16px] font-[500] text-start truncate"
                    >
                        {scenario!.name}
                    </button>
                </Tooltip>
            </DropdownButton>
            <DropdownItems>
                {recentScenarios?.map((scenario) => (
                    <DropdownItem key={scenario.id}
                                  className="popover-item popover-text-400"
                                  onClick={() => onClickScenario(scenario.id)}
                    >
                        {scenario.name}
                    </DropdownItem>
                ))}

                <DropdownFooter className="popover-item popover-text-400 border-chat42-50"
                                onClick={onClickMore}
                >
                    {intl.formatMessage({ id: "i00001" })}
                </DropdownFooter>
            </DropdownItems>
        </DropdownGroup>
    );
};

export default ScenarioDropdown;